import { useEffect } from "react";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const SS_KEY = "mva_attribution";

function safeReadStored() {
  try {
    return JSON.parse(sessionStorage.getItem(SS_KEY) || "{}");
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("Could not read attribution from sessionStorage:", err?.message);
    return {};
  }
}

function safeWriteStored(payload) {
  try {
    sessionStorage.setItem(SS_KEY, JSON.stringify(payload));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("Could not persist attribution to sessionStorage:", err?.message);
  }
}

/** Persist first-touch attribution from the URL + referrer into sessionStorage. */
export function captureAttributionFromUrl() {
  if (typeof window === "undefined") return;
  const stored = safeReadStored();
  const params = new URLSearchParams(window.location.search);
  let dirty = false;
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v && !stored[k]) {
      stored[k] = v;
      dirty = true;
    }
  });
  if (!stored.referrer && document.referrer) {
    stored.referrer = document.referrer;
    dirty = true;
  }
  if (!stored.landing_page) {
    stored.landing_page = window.location.pathname + window.location.search;
    dirty = true;
  }
  if (dirty) safeWriteStored(stored);
}

/** Pull stored attribution data to merge into form submissions. */
export function getAttribution() {
  if (typeof window === "undefined") return {};
  return safeReadStored();
}

/** Hook for the app root — captures once on mount. */
export function useAttribution() {
  useEffect(() => {
    captureAttributionFromUrl();
  }, []);
}
